module.exports = __webpack_public_path__ + "img/plate_placeholder.90e5c0f3.png";